import { render, staticRenderFns } from "./RaffleEvent.vue?vue&type=template&id=ff8fb33c"
import script from "./RaffleEvent.vue?vue&type=script&lang=js"
export * from "./RaffleEvent.vue?vue&type=script&lang=js"
import style0 from "./RaffleEvent.vue?vue&type=style&index=0&id=ff8fb33c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports